import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';


/*Ejemplo implementacion de un pipe toma texto html y se asegura
  que sea interpretado como codigo seguro por el visualizador*/
@Pipe({ name: 'safeHtml' })
export class SafeHtmlPipe implements PipeTransform {

  //Constructor de la clase
  constructor(private sanitizer: DomSanitizer) { }

  /*Necesario debido a implementacion de la interfaz PipeTransform
    metodo principal del pipe, recibe un valor y realiza
    las transformaciones necesarias*/
  transform(value: any) {
    return this.sanitizer.bypassSecurityTrustHtml
      (value);
  }
}
